const STORAGE_KEY = 'logoutConfirmationHidden';

export function isLogoutConfirmationHidden(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    // localStorage unavailable (private mode / disabled): treat as not hidden.
    return false;
  }
}

export function setLogoutConfirmationHidden(hidden: boolean): void {
  try {
    if (hidden) {
      localStorage.setItem(STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // localStorage unavailable: preference is best-effort.
  }
}
